import { withStyles } from '@mui/styles';

import FirmForm from './FirmForm';
import muiStyles from './styles';

export default withStyles(muiStyles)(FirmForm as any);